import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
//
import AllRoutes from './routes';
import ErrorBoundary from './components/ErrorBoundary';
//
import 'react-toastify/dist/ReactToastify.css';
import './toast-overrides.css';

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ToastContainer
          autoClose={3000}
          theme="light"
          position="top-center"
          draggable
          hideProgressBar
          closeButton={false}
          toastClassName="custom-toast"
          bodyClassName="custom-toast-body"
        />
        <AllRoutes />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
